import React, {cloneElement} from "react";

export function updateSubmit(
    button: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>],
    title: string,
    loading: boolean = false
) {
    button[1](
        cloneElement(
            button[0],
            {"loading": loading},
            title
        )
    )
}